import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/PassPhrase/types';
import { PassPhraseActions, MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP, MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE, MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE, MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): PassPhraseActions => ({
  type: MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 驗證會員密碼 (Action)
 * @param args 請求所需的參數
 */
export const authPassPhraseAction = (args: AaSigninReq): PassPhraseActions => ({
  type: MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE,
  payload: { args }
});

/**
 * @description 設置會員密碼 (Action)
 * @param args 請求所需的參數
 */
export const setupPassPhraseAction = (args: MbUpdateinfoReq): PassPhraseActions => ({
  type: MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE,
  payload: { args }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): PassPhraseActions => ({
  type: MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE
});
